import { useSearchParams } from "react-router-dom";
import { PageContainer } from "@/components/layout/PageContainer";
import { performSiteSearch, SearchResult } from "@/utils/search";
import { Card } from "@/components/ui/card";
import { FileText } from "lucide-react";

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const results = performSiteSearch(query);

  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="space-y-4">
          <h1 className="text-3xl font-bold">Search Results</h1>
          <p className="text-gray-600">
            {results.length} results found for "{query}"
          </p>
        </div>

        {results.length > 0 ? (
          <div className="space-y-4">
            {results.map((result: SearchResult, index: number) => (
              <Card key={index} className="p-4 hover:shadow-md transition-shadow">
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <FileText className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <h2 className="text-lg font-semibold mb-1">{result.title}</h2>
                    <p className="text-gray-600 text-sm">{result.description}</p>
                    <div className="mt-2">
                      <span className="text-xs px-2 py-1 bg-gray-100 rounded-full">
                        {result.type}
                      </span>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        ) : (
          <Card className="p-6 text-center">
            <p className="text-gray-600">No results found for your search.</p>
          </Card>
        )}
      </div>
    </PageContainer>
  );
};

export default SearchResults;